import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"
import { Redirect } from 'react-router-dom'

import {
  addClass,
  removeClass,
  clearFormError,
  getJSON
} from '../components/GlobalFunctions';

import SingleInput from '../components/SingleInput';

import ReCAPTCHA from '../components/ReCaptcha';

import SHA256 from "crypto-js/sha256";

import cookie from 'react-cookies'

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import logo from '../img/logo.svg'
import logo_new_year from '../img/logo_new-year.svg'

import ogp_cover from '../img/cover.png'

let reCaptcha;

export default class Login extends React.Component {

  constructor(props) {
    super(props);

    this.onInputFocus = this.onInputFocus.bind(this);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleFacebook = this.handleFacebook.bind(this);

    this.initFacebook = this.initFacebook.bind(this);
    this.statusFacebookCallback = this.statusFacebookCallback.bind(this);

    this.checkForm = this.checkForm.bind(this);
    this.postDataForm = this.postDataForm.bind(this);
    this.postFacebookDataForm = this.postFacebookDataForm.bind(this);
    this.state = {
      statusPage: false,
      redirectPage: false,
      redirectPath: '',
      email: '',
      password: '',
      type: 'login',
      facebookAccessToken: '',
      facebookSignedRequest: '',
      facebookType: 'login',

      loginError: '',
      loginDisabled: false,
      facebookDisabled: false
    };
  }

  pageClick(e) {document.getElementsByTagName('body')[0].className=''}

  onInputFocus(s){ addClass(s.target.parentNode,"input--filled"),this.setState({ loginError: '' });  }

  onInputBlur(s){ ""===s.target.value.trim()&&removeClass(s.target.parentNode,"input--filled") }

  handleEmailChange(e) { this.setState({ email: e.target.value }) }

  handlePasswordChange(e) { this.setState({ password: e.target.value }) }

  postDataForm(token) {
    const self = this;
    const username = this.state.email;
    const {
      password,
      type
    } = this.state;
    const d = new Date();
    const time_zone_offset = d.getTimezoneOffset();
    const recaptchaToken = token ? `&recaptchaToken=${token}` : '';

    getJSON('POST', '/api/auth', 'username='+username+'&password='+SHA256(password)+'&time_zone_offset='+time_zone_offset+'&type='+type+recaptchaToken, async function(data){var dataArray=JSON.parse(data);
      if (dataArray.type && dataArray.type !== type) {
        self.setState({ loginError: '<p class="info">'+dataArray.message+'</p>', type: dataArray.type });

        if (+process.env.RECAPTCHA_ENABLED) {
          const currentRecaptchaToken = await reCaptcha.getRecaptchaToken();
          self.postDataForm(currentRecaptchaToken);
        } else {
          self.postDataForm();
        }

      } else {
        switch (type) {
          case 'reactivate':
            window.location.assign(process.env.GATSBY_API_URL+'/orders/available.html');
            break;
          case 'proceed': 
            self.setState({redirectPath: '/register_hash.html'});
            self.setState({redirectPage: true});
            break;
          default:
            window.location.assign(dataArray.redirect ? dataArray.redirect : process.env.GATSBY_API_URL+'/orders/available.html');
        }
      }
    }, function(status){
      var statusArray=JSON.parse(status);

      if(statusArray.fields && statusArray.fields !== 'undefined') {
        var loginErrorFields = '';
        if(statusArray.fields.length>0) {
          for (var i = 0; i < statusArray.fields.length; i++) {
            loginErrorFields += '<p>'+statusArray.fields[i]+'</p>';
          }
        }
        self.setState({ loginError: loginErrorFields });
      } else if(statusArray.message && statusArray.message !== 'undefined') {
        self.setState({ loginError: '<p>'+statusArray.message+'</p>' });
      }
      self.setState({ loginDisabled: false });
    });
  }

  async checkForm(e) {
    e.preventDefault();

    var self = this, CookieDialog_agreed = cookie.load('CookieDialog_agreed');
    if(!CookieDialog_agreed) {
      this.setState({ loginError: '<p>Please accept cookie policy to proceed.</p>' });
    } else {
      if (+process.env.RECAPTCHA_ENABLED) {
        try {
          const recaptchaToken = await reCaptcha.getRecaptchaToken();
          self.postDataForm(recaptchaToken);
        } catch (error) {
          self.setState({ loginError: '<p>'+error+'</p>' });
        }
      } else {
        self.postDataForm();
      }
    }
  }

  initFacebook() {
    var self = this;

    if(!document.getElementById('facebook-jssdk')) {
      window.fbAsyncInit = function() {
        FB.init({
          appId: process.env.FACEBOOK_API_APP_KEY,
          cookie: true,
          xfbml: true,
          version: 'v5.0'
        });

      }.bind(self);

      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    }
  }

  async statusFacebookCallback(response) {
    if (response.status === 'connected') {
      this.setState({ facebookAccessToken: response.authResponse.accessToken, facebookSignedRequest: response.authResponse.signedRequest });

      if (+process.env.RECAPTCHA_ENABLED) {
        try {
          const recaptchaToken = await reCaptcha.getRecaptchaToken();
          this.postFacebookDataForm(recaptchaToken);
        } catch (error) {
          this.setState({ loginError: '<p>'+error+'</p>' });
        }
      } else {
        this.postFacebookDataForm();
      }
    } else {
      this.setState({ facebookDisabled: false });
      this.setState({ loginError: '<p>Please log into Facebook.<br>In case you experience any difficulties, please sign in using email and password.</p>' });
    }
  }

  handleFacebook() {
    var self = this, CookieDialog_agreed = cookie.load('CookieDialog_agreed');
    if(!CookieDialog_agreed) {
      self.setState({ loginError: '<p>Please accept cookie policy to proceed.</p>' });
    } else {
      self.setState({ facebookDisabled: true });
      self.setState({ loginError: '' });
      FB.login(function (response) {
        self.statusFacebookCallback(response);
      }, {scope: 'public_profile,email'});
    }
  }

  postFacebookDataForm(token) {
    const self = this;
    const {
      facebookType,
      facebookAccessToken,
      facebookSignedRequest
    } = this.state;
    const recaptchaToken = token ? `&recaptchaToken=${token}` : '';

    getJSON('POST', '/api/facebook/auth', 'token='+facebookAccessToken+'&code='+facebookSignedRequest+'&type='+facebookType+recaptchaToken, async function(data){
      var dataArray=JSON.parse(data);

      if (dataArray.type && dataArray.type !== facebookType) {
        self.setState({ loginError: '<p class="info">'+dataArray.message+'</p>', facebookType: dataArray.type });

        if (+process.env.RECAPTCHA_ENABLED) {
          const currentRecaptchaToken = await reCaptcha.getRecaptchaToken();
          self.postDataForm(currentRecaptchaToken);
        } else {
          self.postDataForm();
        }

      } else {
        switch (facebookType) {
          case 'reactivate':
            window.location.assign(process.env.GATSBY_API_URL+'/orders/available.html');
            break;
          case 'proceed': 
            self.setState({redirectPath: '/register_hash.html'});
            self.setState({redirectPage: true});
            break;
          default:
            window.location.assign(dataArray.redirect ? dataArray.redirect : process.env.GATSBY_API_URL+'/orders/available.html');
        }
      }

    }, function(status){
      self.setState({ statusFacebook: true });

      var statusArray=JSON.parse(status);
      if(statusArray.fields && statusArray.fields !== 'undefined') {
        var loginErrorFields = '';
        if(statusArray.fields.length>0) {
          for (var i = 0; i < statusArray.fields.length; i++) {
            loginErrorFields += '<p>'+statusArray.fields[i]+'</p>';
          }
        }
        self.setState({ loginError: loginErrorFields });
      } else if(statusArray.message && statusArray.message !== 'undefined') {
        self.setState({ loginError: '<p>'+statusArray.message+'</p>' });
      }
      self.setState({ facebookDisabled: false });
    });
  }

  componentDidMount() {
    var self = this;
    getJSON('GET', '/api/auth', null, function(data){
      if(data.log) {
        window.location.assign(process.env.GATSBY_API_URL+'/orders/available.html');
      } else {
        self.setState({statusPage: true});
        self.initFacebook();
      }
    }, function(status){});
  }

  componentDidUpdate() {
    var self = this;
    if(this.state.statusPage) {
      addClass(document.getElementsByTagName('html')[0],"login");
      for(var fieldList=document.querySelectorAll(".input__field"),i=0;i<fieldList.length;i++)""!==fieldList[i].value.trim()&&addClass(fieldList[i].parentNode,"input--filled");
    }
  }

  componentWillUnmount() {
    removeClass(document.getElementsByTagName('html')[0],"login");
  }

  render() {

    if (this.state && this.state.statusPage) {

      if(this.state.redirectPage) {
        return (
          <Redirect to={this.state.redirectPath}/>
        );
      }

      return (
        <div className="login-wrapper">

          <Helmet
            title="Log in to Uvocorp.com using writer's login form - UvoCorp.com"
            meta={[
              { name: "description", content: "Enter your username and password. Log in to Uvocorp.com and view all projects that are currently available for freelance academic writers." },

              { property: 'og:title', content: "Log in to Uvocorp.com using writer's login form - UvoCorp.com" },
              { property: 'og:description', content: "Enter your username and password. Log in to Uvocorp.com and view all projects that are currently available for freelance academic writers." },
              { property: 'og:site_name', content: "UvoCorp.com" },
              { property: 'og:type', content: "website" },
              { property: 'og:image', content: ogp_cover },
            ]}
            link={[
              { rel: 'canonical', href: "https://www.uvocorp.com/login.html" }
            ]} />

          <div className="login-container">
          
            <div className="login-header"> {/* login-header-new_year */}
              <Link to="/"><img src={logo} alt="UVOcorp.com" /></Link> {/* logo_new_year */}
            </div>
            
            <div className="login-body">
            
              <form id="loginForm" className="form" onSubmit={this.checkForm}>
                <div id="loginError" className="form-error" dangerouslySetInnerHTML={{ __html: this.state.loginError }}></div>

                <div className="form-row form-row-facebook">
                  <button id="facebookSubmit" className={'form-facebook'} type="button" onClick={this.handleFacebook} disabled={this.state.facebookDisabled}><svg viewBox="0 0 20 20"><path fill="#ffffff" d="M15,3.6h-1.8c-1.4,0-1.7,0.7-1.7,1.7v2.2h3.4l-0.5,3.4h-2.9v8.8H8v-8.8H5V7.4h3V4.9C8,2,9.7,0.4,12.4,0.4 c1.2,0,2.3,0.1,2.6,0.1V3.6z"/></svg>Log In with Facebook</button>
                </div>
            
                <div className="form-row form-row-or">
                  <div className="form-or">OR</div>
                </div>
            
                <SingleInput
                  inputType={'email'}
                  title={''}
                  name={'loginEmail'}
                  content={this.state.email}
                  controlFunc={this.handleEmailChange}
                  placeholder={'E-mail'}
                  focusFunc={this.onInputFocus}
                  blurFunc={this.onInputBlur}
                  svg={'M13.7,16.4H6.3c-1.3,0-2.2-0.8-2.2-2.2c0-1.9,0.4-4.8,2.9-4.8c0.3,0,1.4,1.2,3,1.2c1.6,0,2.7-1.2,3-1.2c2.5,0,2.9,2.9,2.9,4.8C15.9,15.6,15,16.4,13.7,16.4z M10,10c-1.8,0-3.2-1.4-3.2-3.2S8.2,3.6,10,3.6c1.8,0,3.2,1.4,3.2,3.2S11.8,10,10,10z'}
                  required={true} />
            
                <SingleInput
                  inputType={'password'}
                  title={''}
                  name={'loginPassword'}
                  content={this.state.password}
                  controlFunc={this.handlePasswordChange}
                  placeholder={'Password'}
                  focusFunc={this.onInputFocus}
                  blurFunc={this.onInputBlur}
                  svg={'M14.8,15.1c0,0.4-0.4,0.8-0.8,0.8H6c-0.4,0-0.8-0.4-0.8-0.8v-4.8c0-0.4,0.4-0.8,0.8-0.8h0.3V7.9c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8v1.6H14c0.4,0,0.8,0.4,0.8,0.8V15.1z M12.1,9.5V7.9c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1v1.6H12.1z'}
                  required={true} />
            
                <div className="form-row form-row-submit">
                  <input id="loginSubmit" className={`form-submit`} type="submit" value="Log In" disabled={this.state.loginDisabled} />
                  <Link to="/forgot_password.html">Forgot your password?</Link>
                </div>
                <p>Need an account? <Link to="/register_email.html">Sign up</Link></p>

                { +process.env.RECAPTCHA_ENABLED ? (
                  <ReCAPTCHA
                    ref={e => reCaptcha = e}
                    sitekey={process.env.SITE_KEY}
                  />
                ) : '' }

              </form>
            </div>
          
            <div className="login-footer">
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/contacts.html">Contacts</Link>
                </li>
                <li>
                  <Link to="/prices.html">Pricing policy</Link>
                </li>
              </ul>
            </div>
          
          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login.html.js